<div class="upgrade-modal">
  <div class="illustration">
    <svg-icon icon="update-modal-illustration" [height]="'80px'"></svg-icon>
  </div>
  <h2 class="title">{{ 'Sprucing things up!' | translate }}</h2>
  <p class="description">
    {{
      "We're loading the latest version of Pencil Spaces. Hang tight - we'll refresh your page when it's ready!"
        | translate
    }}
  </p>
  <div class="actions">
    <app-pencil-button
      class="update-button"
      [disabled]="true"
      [showSpinner]="true"
      [label]="'Updating...' | translate"
    ></app-pencil-button>
    <p class="footer" *ngIf="versions?.version">
      {{ 'Estimated time: ~1 min. Version:' | translate }} {{ versions.version }}
    </p>
  </div>
</div>
